export default "__VITE_ASSET__DLu4oMP4__"